/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCheck } from '@fortawesome/pro-solid-svg-icons';

// actions + utils
import { getFileDetails } from '../../actions/rts';
import { cap } from '../../common/utils/prettify';

// components
import { ModalBase, Table } from '../../common/components';
import ReactPagination from 'react-js-pagination';

const PAGE_SIZE = 30;

function DetailsModal() {
  const dispatch = useDispatch();
  const { rtsDetailsModal } = useSelector(store => store.modals);
  const {
    results = [],
    planYear,
    fileFamilyID,
    carrierID,
    fileNameID,
    page,
    totalPages,
    totalCount,
    pageSize,
  } = useSelector(store => (store.rts.details || {}));
  const { selectedFile, detailsListType: listType } = useSelector(store => store.rts);
  const [loading, setLoading] = useState(false);
  const pageCountStart = ((page - 1) * pageSize) + 1;
  let pageCountEnd = page * pageSize;
  if (totalPages === page) pageCountEnd = totalCount;

  function formatDetailsButton(data) {
    return (
      <button
        onClick={() => window.open(`/admin/${data.username}`, '_blank')}
        type="button"
        className="btn btn-link"
      >
        Details
      </button>
    );
  }

  function pageCounts() { return <em>{pageCountStart}-{pageCountEnd} of {totalCount}</em>; }

  function closeModal() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'rtsDetailsModal' });
    dispatch({ type: 'CLEAR_RTS_DETAILS_MODAL' });
  }

  function loadPage(page) {
    setLoading(true);
    getFileDetails({
      ...selectedFile,
      page,
      listType,
      pageSize: PAGE_SIZE,
    })
      .then((res) => {
        dispatch({ type: 'SET_RTS_FIELD', payload: { details: res } });
      }).finally(() => setLoading(false));
  }

  // initial file load on modal open
  useEffect(() => loadPage(1), [selectedFile]);

  return (
    <ModalBase
      title={`Agent ${cap(listType)} List`}
      isOpen={rtsDetailsModal}
      closeModalAction={() => closeModal()}
      staticWidth="95%"
      allowOverlayClickClose
    >
      <div className="row p-3">
        <div className="col">
          {pageCounts()}
        </div>
      </div>

      <div className="p-3">
        <Table
          loading={loading}
          className="table table-striped"
          schema={{
            cols: [
              { header: 'First Name', field: 'firstName' },
              { header: 'Last Name', field: 'lastName' },
              { header: 'NPN', field: 'npn' },
              { header: 'CPC', field: 'cpcID' },
              { header: 'Last File That Updated Agent', field: 'lastFileSource' },
              { header: 'Details', passAllData: true, formatter: formatDetailsButton },
            ],
          }}
          data={results}
        />
      </div>

      <div className="row p-3">
        <div className="col-md-4">
          {pageCounts()}
        </div>
        <div className="col-md-4">
          <ReactPagination
            activePage={page}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            innerClass="pagination justify-content-center"
            itemClass="page-item"
            linkClass="page-link"
            onChange={(pageNum) => loadPage(pageNum)}
          />
        </div>
      </div>

    </ModalBase>
  );
}

export default DetailsModal;
